module.exports = __webpack_public_path__ + "img/2.784eeaa7.jpg";